import React, { ReactElement, useEffect, useState } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { BUOY_TYPES, initMainImagePopup } from '../../../../utils';
import { PortAndWaterwayObject } from '../../../../types';

interface DetailPageProps {
  portAndWaterwayObject?: PortAndWaterwayObject;
}

export default function DetailPage({ portAndWaterwayObject }: DetailPageProps): ReactElement {
  const [imageFound, setImageFound] = useState(false);
  useEffect(() => {
    if (portAndWaterwayObject?.image) {
      const img = new Image();
      img.addEventListener('load', () => {
        setImageFound(true);
      });
      img.src = portAndWaterwayObject.image;
    }
  }, [portAndWaterwayObject]);
  useEffect(() => {
    if (imageFound) {
      const $imageContainer = $('.node-main-image');
      const src = $imageContainer.data('src');
      initMainImagePopup($imageContainer, src);
    }
  }, [imageFound]);
  if (!portAndWaterwayObject) {
    return null;
  }
  const buoyInfo = BUOY_TYPES.includes(portAndWaterwayObject.type) ? (
    <dl>
      <dt>Båtportskod</dt>
      <dd>{(portAndWaterwayObject.boatGateCode && portAndWaterwayObject.boatGateCode) || '-'}</dd>
      <dt>Sjökortsnummer</dt>
      <dd>{(portAndWaterwayObject.chartNumber && portAndWaterwayObject.chartNumber) || '-'}</dd>
    </dl>
  ) : null;
  return (
    <>
      <div id="block-sxk-theme-page-title" className="contextual-region block block-core block-page-title-block">
        <div className="block-content">
          <div className="page-title-box">
            <div className="page-title-box-inner content-bg">
              <h1>
                <span className="field field--name-title field--type-string">{portAndWaterwayObject.name}</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <article>
        <div className="node__content clearfix">
          <div className="node-content-inner content-bg">
            <div className="node-main-wrap clearfix">
              {imageFound && (
                <div
                  className="node-main-image mfp-item"
                  data-src={portAndWaterwayObject.image}
                  style={{ backgroundImage: `url('${portAndWaterwayObject.image}')` }}
                />
              )}
              <div className="node-main-content">
                <div className="node-ingress" />

                <div className="wysiwyg-content">
                  <div className="buoy-info">{buoyInfo}</div>

                  <span dangerouslySetInnerHTML={{ __html: portAndWaterwayObject.description }} />
                </div>
                <div className="field__label">Koordinater</div>
                <div className="node-geo icon-coordinates">{portAndWaterwayObject.position}</div>
              </div>
            </div>

            <div className="node-footer clearfix">
              <Link to={`/sjokort/${portAndWaterwayObject.latitude},${portAndWaterwayObject.longitude},17`}>Visa i sjökort</Link>
            </div>
          </div>
        </div>
      </article>
      <br />
      <button onClick={() => history.back()}>Tillbaka</button>
    </>
  );
}
